import { useState } from "react";
import API_BASE from "../config";

export default function Home() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    department: "",
    doctor: "",
    date: "",
    message: "",
  });

  const specialties = [
    {
      title: "Cardiology",
      doctor: "Dr. M. Juneja",
      desc: "Heart care specialists.",
    },
    {
      title: "Neurology",
      doctor: "Dr. Anjali Mehta",
      desc: "Brain and nervous system.",
    },
    {
      title: "Orthopedics",
      doctor: "Dr. Rohan Patil",
      desc: "Bone and joint care.",
    },
    {
      title: "Pediatrics",
      doctor: "Dr. Neha Sharma",
      desc: "Children's health.",
    },
    {
      title: "Dermatology",
      doctor: "Dr. Priya Kapoor",
      desc: "Skin care experts.",
    },
  ];

  const doctorsByDepartment = {
    Cardiology: ["Dr. M. Juneja"],
    Neurology: ["Dr. Anjali Mehta"],
    Orthopedics: ["Dr. Rohan Patil"],
    Pediatrics: ["Dr. Neha Sharma"],
    Dermatology: ["Dr. Priya Kapoor"],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "department") {
      const doctors = doctorsByDepartment[value] || [];

      setFormData({
        ...formData,
        department: value,
        doctor: doctors.length > 0 ? doctors[0] : "",
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE}/addAppointment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          patient_name: formData.name,
          email: formData.email,
          department: formData.department,
          doctor: formData.doctor,
          appointment_date: formData.date,
          message: formData.message,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Appointment booked successfully!");

        setFormData({
          name: "",
          email: "",
          department: "",
          doctor: "",
          date: "",
          message: "",
        });
      } else {
        alert(result.message || "Failed to book appointment.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to book appointment. Please try again.");
    }
  };

  return (
    <div className="pt-16 sm:pt-20 bg-white dark:bg-gray-900 text-gray-900 dark:text-white overflow-x-hidden">

      {/* ================= HERO ================= */}
      <section
        className="relative min-h-[520px] sm:min-h-[560px] flex items-center justify-center py-16 sm:py-20 px-4 sm:px-6 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('/banner.jpg')` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 w-full max-w-5xl mx-auto text-center">

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            Care You Can Trust.
            <br className="hidden sm:block" />
            Health You Deserve.
          </h1>

          <p className="text-base sm:text-lg md:text-xl mb-8 max-w-2xl mx-auto text-white leading-relaxed">
            Providing comprehensive medical services with compassion and
            expertise.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 px-4">

            <a
              href="#appointment"
              className="w-full sm:w-auto bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
            >
              Book Appointment
            </a>

            <a
              href="#footer"
              className="w-full sm:w-auto bg-white text-gray-800 px-6 py-3 rounded-lg hover:bg-gray-200 transition font-semibold"
            >
              Contact Us
            </a>

          </div>
        </div>
      </section>


      {/* ================= APPOINTMENT ================= */}
      <section
        id="appointment"
        className="relative py-12 sm:py-16 px-4 sm:px-6 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('/hospital photo.jpg')` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 w-full max-w-4xl mx-auto">

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6 sm:mb-8 text-white">
            Book an Appointment
          </h2>

          <form
            onSubmit={handleSubmit}
            className="bg-white dark:bg-gray-700 p-4 sm:p-6 md:p-8 rounded-xl shadow-xl grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6 w-full"
          >

            {/* Patient Name */}
            <input
              type="text"
              name="name"
              placeholder="Patient Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Email */}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Department */}
            <select
              name="department"
              value={formData.department}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select Department</option>
              <option value="Cardiology">Cardiology</option>
              <option value="Neurology">Neurology</option>
              <option value="Orthopedics">Orthopedics</option>
              <option value="Pediatrics">Pediatrics</option>
              <option value="Dermatology">Dermatology</option>
            </select>

            {/* Doctor */}
            <select
              name="doctor"
              value={formData.doctor}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
              disabled={!formData.department}
            >
              <option value="">
                {formData.department
                  ? "Select Doctor"
                  : "Select Department First"}
              </option>

              {formData.department &&
                doctorsByDepartment[formData.department]?.map(
                  (doctor, index) => (
                    <option key={index} value={doctor}>
                      {doctor}
                    </option>
                  )
                )}
            </select>

            {/* Date */}
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Message */}
            <textarea
              name="message"
              placeholder="Message (Optional)"
              value={formData.message}
              onChange={handleChange}
              className="w-full min-w-0 p-3 sm:p-3.5 border rounded-lg dark:bg-gray-600 dark:border-gray-500 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 md:col-span-2"
              rows="4"
            ></textarea>

            {/* Submit */}
            <button
              type="submit"
              className="w-full md:col-span-2 bg-blue-600 text-white py-3 sm:py-3.5 rounded-lg hover:bg-blue-700 transition font-semibold text-base sm:text-lg"
            >
              Submit Appointment
            </button>

          </form>
        </div>
      </section>


      {/* ================= ABOUT ================= */}
      <section
        id="about"
        className="py-12 sm:py-16 px-4 sm:px-6 bg-blue-50 dark:bg-gray-800"
      >
        <div className="max-w-4xl mx-auto text-center">

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8">
            About Our Hospital
          </h2>

          <p className="text-base sm:text-lg leading-relaxed mb-8">
            City Multispecialty Hospital is dedicated to providing high-quality
            healthcare services to our community.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">

            <div className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-md">
              <h3 className="text-xl font-semibold mb-3">
                Mission
              </h3>
              <p className="leading-relaxed">
                To deliver compassionate, patient-centered care with
                excellence and integrity.
              </p>
            </div>

            <div className="bg-white dark:bg-gray-700 p-6 rounded-xl shadow-md">
              <h3 className="text-xl font-semibold mb-3">
                Vision
              </h3>
              <p className="leading-relaxed">
                To be the leading healthcare provider, setting standards in
                medical innovation and service.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* ================= SPECIALTIES ================= */}
      <section
        id="specialties"
        className="py-12 sm:py-16 px-4 sm:px-6 bg-gray-50 dark:bg-gray-800"
      >
        <div className="max-w-6xl mx-auto">

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12">
            Our Specialties
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">

            {specialties.map((spec, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-700 p-5 sm:p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition"
              >

                <h3 className="text-lg sm:text-xl font-semibold mb-2">
                  {spec.title}
                </h3>

                <p className="text-blue-600 dark:text-blue-400 font-medium mb-2">
                  {spec.doctor}
                </p>

                <p className="text-sm sm:text-base">
                  {spec.desc}
                </p>

              </div>
            ))}

          </div>
        </div>
      </section>


      {/* ================= TIMINGS ================= */}
      <section
        className="py-12 sm:py-16 px-4 sm:px-6 bg-white dark:bg-gray-900 text-center"
      >

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8">
          Hospital Timings
        </h2>

        <div className="max-w-md mx-auto bg-blue-50 dark:bg-gray-800 p-5 sm:p-6 rounded-xl shadow-md">

          <p className="text-base sm:text-lg mb-3">
            Monday – Saturday:
            <br className="sm:hidden" />
            {" "}9:00 AM – 8:00 PM
          </p>

          <p className="text-base sm:text-lg text-red-600 dark:text-red-400 font-semibold">
            Sunday: Closed
          </p>

        </div>
      </section>


      {/* ================= FOOTER ================= */}
      <footer
        id="footer"
        className="bg-blue-600 dark:bg-blue-800 text-white py-8 sm:py-10 px-4 sm:px-6"
      >
        <div className="max-w-4xl mx-auto text-center">

          <h3 className="text-xl sm:text-2xl font-bold mb-4">
            City Multispecialty Hospital
          </h3>

          <p className="mb-2 text-sm sm:text-base break-words">
            Contact: info@cityhospital.com
          </p>

          <p className="mb-4 text-sm sm:text-base">
            Phone: (123) 456-7890
          </p>

          <p className="text-xs sm:text-sm">
            © 2026 City Multispecialty Hospital. All rights reserved.
          </p>

        </div>
      </footer>

    </div>
  );
}
